import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch } from "react-redux";

import { useSingleSavedSearch } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/query";
import type { SavedSearchRoutingParams } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/types";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import { toggleNotFoundLeadGenModalOpen } from "app/pages/sales-intelligence/sub-modules/common/store/action-creators";

export const useSavedSearchFetch = (): void => {
    const dispatch = useDispatch();

    const {
        params: { savedSearchId },
    } = useCurrentStateAndParams<SavedSearchRoutingParams>();

    const { isError } = useSingleSavedSearch(savedSearchId);

    useEffect(() => {
        if (savedSearchId && isError) {
            void siNavigator.goToAdvancedSearchPage({ location: "replace" });

            dispatch(toggleNotFoundLeadGenModalOpen(true));
        }
    }, [savedSearchId, isError, dispatch]);
};
